var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h2',[_vm._v("News")]),_c('br'),_c('news-list',{attrs:{"newsItemList":_vm.newsList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }